import React from 'react';
import { TableCell, TableRow} from '@mui/material';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import {OutlinedInput, MenuItem, Chip, Stack} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import styled from 'styled-components';

const ButtonWrapper = styled.div`
  display: flex;
`

const AppIndAsstEditable = ({k,row, editFormData, handleCancelClick, newValue,assetmaster,
  page, rowsPerPage, onChangeEditAppIndAsst,  SubmitButton}) =>{
   return( 
   <>
     <TableRow key={k} name={row.Category}>
       <TableCell component="th" scope="row">
         {(page)*(rowsPerPage)+k+1}
       </TableCell>
         
       <TableCell  align="left">
        <Autocomplete
            disablePortal
            id="combo-box-demo"
            size='small'
            value={editFormData?.asset}
            onChange={(event, newValue) => onChangeEditAppIndAsst(event, newValue, "asset" , row.id)}
            options={(assetmaster && editFormData?.category?.length)? Object.values(assetmaster)?.find(x => x.Category === editFormData?.category)?.Asset?.map(y => y.Name):[]}
            sx={{backgroundColor:"white", width:"200px",  marginRight:"20px",height:"40px"}}
            renderInput={(params) => <TextField {...params} label={"Select Asset"} />}
          />
       </TableCell>

       <TableCell  align="left">
         <Autocomplete
             disablePortal
             id="combo-box-demo"
             size='small'
             value={editFormData?.category}
             onChange={(event, newValue) => onChangeEditAppIndAsst(event, newValue, "category", row.id)}
             options={assetmaster? Object.values(assetmaster)?.map(x => x?.Category): []}
             sx={{backgroundColor:"white", width:"200px", marginRight:"20px",height:"40px"}}
             renderInput={(params) => <TextField {...params} label={"Select Category"} />}
           />
       </TableCell>

       <TableCell  align="left">
         <Autocomplete
             disablePortal
             id="combo-box-demo"
             size='small'
             value={editFormData?.dual}
             onChange={(event, newValue) => onChangeEditAppIndAsst(event, newValue, "dual", row.id)}
             options={assetmaster? ["true", "false"]: []}
             sx={{backgroundColor:"white", width:"200px", marginRight:"20px",height:"40px"}}
             renderInput={(params) => <TextField {...params} label={"Dual Applicable"} />}
           />
       </TableCell>

       <TableCell align="left">
         <ButtonWrapper>
           <SubmitButton style={{marginRight:'10px'}} type="submit">Save</SubmitButton>
           <SubmitButton style={{marginRight:'10px'}} type="button" onClick={(e)=>handleCancelClick(e,k)}
           >Cancel</SubmitButton>
         </ButtonWrapper>                         
   </TableCell>
 </TableRow>     
       </>         
   )
}

export default AppIndAsstEditable